// import anime from "animejs";


(function($) {
  var header = $(".header");

  // $(".backplate").click(function() {
  //   $(".menu-tendina").removeClass("menu-tendina--active");
  //   $(".o-popup").removeClass("o-popup--open");
  //   $(".hamburger").removeClass("is-active");
  //   $(".menu-tendina__sub").removeClass("menu-tendina__sub--active");
  //   $(".btn-nav").removeClass("btn-nav--active");
  //   $(this).removeClass("backplate--open");

  //   $(".lista-orari").removeClass("lista-orari--active");
  //   $(".menu-tendina").removeClass("menu-tendina--orari");
  // });


  $(".header-mobile__trigger").click(function() {
    $(".menu-tendina").toggleClass("menu-tendina--active");
    $(".hamburger").toggleClass("is-active");

    // Blocca/sblocca lo scroll del sito quando il menu è aperto/chiuso
    $('body').toggleClass('no-scroll');

    // Chiudi tutti i submenu se il menu principale viene chiuso
    if (!$(".menu-tendina").hasClass("menu-tendina--active")) {
      // Assumi che `closeAllSubmenus` sia definita nel tuo script JavaScript precedente
      closeAllSubmenus(); // Chiama questa funzione per chiudere tutti i submenu
      $('body').removeClass('no-scroll'); // Assicurati che lo scroll sia riabilitato quando il menu viene chiuso
    }

    // if (!$(this).hasClass("header-mobile__trigger--scroll")) {
    //   $('html, body').animate({
    //     scrollTop: 35
    //   });
    // }

  });


    $('.language-switcher').on('click', function(e) {
      console.log('click')
        e.stopPropagation();
        $(this).find('.language-switcher__dropdown').toggleClass('hidden');
    });

    $(document).on('click', function() {
        $('.language-switcher__dropdown').addClass('hidden');
    });



  // Header follow
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    // if (scroll >= $(window).height()) {
    //   header.addClass("active-scroll");
    // } else {
    //   header.removeClass("active-scroll");
    // }

    if (scroll >= 35) {
      header.addClass("header--scroll");
      $('.header-mobile__trigger').addClass('header-mobile__trigger--scroll');
    } else {
      header.removeClass("header--scroll");
      $('.header-mobile__trigger').removeClass('header-mobile__trigger--scroll');
    }
  });

})(jQuery);



/********
 * codice per creare il sottomenù di wordpress che si apra a slide con le frecce per tornare indietro
 */
document.addEventListener("DOMContentLoaded", function() {
  const menuStack = [];  // Stack per tenere traccia dei menu aperti


  // Funzione per creare l'intestazione del submenu
  function createSubmenuHeader() {
    const header = document.createElement('div');
    header.className = 'submenu-header';
    header.innerHTML = `<button class="back-button">
    <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="38" height="38" rx="2.5" stroke="#101010"/>
    <path d="M21.6875 23.875L17.3125 19.5L21.6875 15.125" stroke="#101010" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    </button><span class="submenu-title"></span>`;
    return header;
  }

  // Aggiunta dinamica di intestazioni del submenu
  document.querySelectorAll('.sub-menu').forEach(menu => {
    menu.prepend(createSubmenuHeader());
  });

  // Funzione per aprire un submenu
  function openSubmenu(submenu, parentItem) {
    closeUnrelatedSubmenus(submenu);

    submenu.style.display = 'block';
    submenu.style.left = '100%';
    
    setTimeout(() => {
      submenu.style.transition = 'left 0.3s ease-in-out';
      submenu.style.left = '0';
      submenu.classList.add('submenu-active');
    }, 10);

    if (!menuStack.includes(submenu)) {
      menuStack.push(submenu);
    }

    const title = submenu.querySelector('.submenu-title');
    title.textContent = parentItem.textContent;
  }

  // Gestione click su tutti gli elementi del menu
  document.querySelectorAll('.menu-item > a, .menu-item-link > a').forEach(item => {
    item.addEventListener('click', function(e) {
      const parentItem = this.closest('.menu-item, .menu-item-link');
      const submenu = parentItem.querySelector('.sub-menu');
      
      if (submenu) {
        e.preventDefault();
        e.stopPropagation();
        openSubmenu(submenu, this);
      }
      // Se non c'è un submenu, l'evento click non viene interrotto e il link funzionerà normalmente
    });
  });

  // Gestione del pulsante indietro
  document.addEventListener('click', function(e) {
    if (e.target.closest('.back-button')) {
      if (menuStack.length > 1) {
        const currentMenu = menuStack.pop();
        currentMenu.style.left = '100%';
        setTimeout(() => {
          currentMenu.classList.remove('submenu-active');
          currentMenu.style.display = 'none';
        }, 300);

        const previousMenu = menuStack[menuStack.length - 1];
        previousMenu.style.display = 'block';
        previousMenu.style.left = '-100%';
        setTimeout(() => {
          previousMenu.style.left = '0';
          previousMenu.classList.add('submenu-active');
        }, 10);
      } else if (menuStack.length === 1) {
        closeAllSubmenus();
      }
    }
  });

  // Gestione hover per menu di secondo e terzo livello (solo per tipo 'mega')
  const menuItems = document.querySelectorAll('.submenu-lev-1 .menu-item-link, .submenu-lev-2 .menu-item-link');
  menuItems.forEach(item => {
    item.addEventListener('mouseenter', function() {
      const parentIndex = this.dataset.index;
      const submenu = this.closest('.submenu');
      const level = this.closest('.submenu-lev-1') ? 2 : 3;

      
      if (submenu.classList.contains('submenu--mega')) {
        // Nascondi tutti gli elementi del livello corrente e successivo
        submenu.querySelectorAll(`.submenu-lev-${level} .menu-item-link, .submenu-immagine__lev-${level}__item > .immagine-menu`).forEach(el => el.classList.add('hide'));
        
        // Mostra gli elementi corrispondenti
        submenu.querySelectorAll(`.submenu-lev-${level} .menu-item-link[data-parent-index="${parentIndex}"], .submenu-immagine__lev-${level}__item[data-parent-index="${parentIndex}"] > .immagine-menu`)
        .forEach(el => el.classList.remove('hide'));
        

        // Aggiorna l'immagine del livello corrente
        submenu.querySelectorAll(`.submenu-immagine__lev-${level-1} .immagine-menu`).forEach(img => img.classList.add('hide'));
        submenu.querySelector(`.submenu-immagine__lev-${level-1} .immagine-menu[data-index="${parentIndex}"]`).classList.remove('hide');
      }
    })
  });



  document.querySelector('.submenu-lev-2')?.addEventListener('mouseleave', function(e) {
    document.querySelectorAll('.submenu-immagine__lev-2 .immagine-menu').forEach(img => img.classList.add('hide'));
  });

  function closeUnrelatedSubmenus(subMenuToKeep) {
    menuStack.forEach(menu => {
      if (menu !== subMenuToKeep && !menu.contains(subMenuToKeep)) {
        menu.style.left = '100%';
        setTimeout(() => {
          menu.classList.remove('submenu-active');
          menu.style.display = 'none';
        }, 300);
      }
    });
  }

  function closeAllSubmenus() {
    while (menuStack.length) {
      const menu = menuStack.pop();
      menu.style.left = '100%';
      setTimeout(() => {
        menu.classList.remove('submenu-active');
        menu.style.display = 'none';
      }, 300);
    }
  }

  // Rendila disponibile globalmente
  window.closeAllSubmenus = closeAllSubmenus;
});
